<template>
  <div id="mobility-video" :class="classes">
    <div v-for="n in 21" :key="n" class="video-wrapper">
      <transition name="fade">
        <video
          :src="getVideoPath(n)"
          autoplay
          loop
          muted
          v-if="n - 1 == year"
          :id="`video-${n}`"
          :title="altText[n - 1]"
          webkit-playsinline 
          playsinline
        ></video>
      </transition>
    </div>
  </div>
</template>

<script>
import yearListenerMixin from "@/mixins/yearListenerMixin";

export default {
  name: "MobilityVideo",
  props: ["classes"],
  mixins: [yearListenerMixin],
  data() {
    return {
      videos: {
        0: { video: "healthy", speed: 1 },
        1: { video: "healthy", speed: 1 },
        2: { video: "spms_no_cane", speed: 1 },
        3: { video: "early_rrms", speed: 1 },
        4: { video: "spms_cane", speed: 1.1 },
        5: { video: "late_rrms", speed: 1.1 },
        6: { video: "late_rrms", speed: 1 },
        7: { video: "spms_cane", speed: 1 },
        8: { video: "spms_no_cane", speed: 1.3 },
        9: { video: "spms_no_cane", speed: 1.2 },
        10: { video: "spms_no_cane", speed: 1.1 },
        11: { video: "spms_cane", speed: 1.1 },
        12: { video: "spms_no_cane", speed: 1 },
        13: { video: "spms_cane", speed: 1.4 },
        14: { video: "spms_cane", speed: 1.3 },
        15: { video: "spms_cane", speed: 1.2 },
        16: { video: "spms_cane", speed: 1.1 },
        17: { video: "spms_cane", speed: 1 },
        18: { video: "wheelchair", speed: 1.2 },
        19: { video: "wheelchair", speed: 1.1 },
        20: { video: "wheelchair", speed: 1 },
      },
      altText: [
        "Patient walking with a normal gait, reflecting an E D S S score of 0.",
        "Patient walking with a slower gait, reflecting an E D S S score of 2.",
        "Patient walking with gait dysfunction, reflecting an E D S S score of 5.5.",
        "Patient walking with gait impairment, reflecting an E D S S score of 2.5.",
        "Patient walking with a cane, reflecting an E D S S score of 6.5.",
        "Patient walking slowly with gait impairment, reflecting an E D S S score of 3.5.",
        "Patient walking slowly with gait impairment, reflecting an E D S S score of 3.5.",
        "Patient walking with a cane, reflecting an E D S S score of 6.",
        "Patient walking with gait dysfunction, reflecting an E D S S score of 5.",
        "Patient walking slowly with gait dysfunction, reflecting an E D S S score of 5.",
        "Patient walking slowly with gait dysfunction, reflecting an E D S S score of 5.",
        "Patient walking slowly with a cane, reflecting an E D S S score of 6.5.",
        "Patient walking with gait disturbance, reflecting an E D S S score of 5.5.",
        "Patient walking slowly with a cane, reflecting an E D S S score of 6.",
        "Patient walking slowly with a cane, reflecting an E D S S score of 6.",
        "Patient walking slowly with a cane, reflecting an E D S S score of 6.5.",
        "Patient walking slowly with a cane, reflecting an E D S S score of 6.5.",
        "Patient walking slowly with a cane, reflecting an E D S S score of 6.5.",
        "Patient seated in a wheelchair, reflecting an E D S S score of 7.",
        "Patient seated in a wheelchair, reflecting an E D S S score of 7.5.",
        "Patient seated in a wheelchair, reflecting an E D S S score of 8.",
      ],
    };
  },
  methods: {
    getVideoPath(index) {
      this.setPlayBackRate(index, this.videos[index - 1].speed);
      return require(`../assets/video/mobility_${
        this.videos[index - 1].video
      }.mp4`);
    },
    setPlayBackRate(index, speed) {
      setTimeout(function () {
        let video = document.getElementById("video-" + index);
        video.playbackRate = speed;
      }, 1);
    },
  },
};
</script>

<style lang="scss">
#mobility-video {
  position: relative;

  #video-border-fade {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: inset 0 0 50px 20px $blue-dark-bg;
    z-index: 1;
  }

  #video-border-fade {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: inset 0 0 50px 20px $blue-dark-bg;
    z-index: 1;
  }

  .video-wrapper {
    position: absolute;
    margin: 1px;
    top: 0;
    left: 0;
    z-index: 0;

    width: 100%;

    video {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  &.scaled {
    transform: scale(0.8);
    position: absolute;
    width: 100%;
    height: 100%;
  }

  &.relative {
    .video-wrapper {
      position: relative;
      overflow: hidden;
    }
  }
}
</style>